<div class="profile-container">
    <div class="">
        <div class="profile-content">
  
            <div class="personal-details">
              <div class="header-block">
                <div class="header-title">
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                  <div class="display-grid">
                    <i (click)="toggleGrid()" class="bi bi-border-all"></i>
                  </div>
                    <div class="search">
                        <form autocomplete="off" >
                            <input type="text" placeholder="search">
                        </form>
                        <i class="bi bi-search" ></i>
                    </div>
                    <button data-toggle="modal" data-target="#deviceModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                    <div class="filter-icon">
                      <i class="bi bi-funnel" (click)="toggleFilter()"></i>
                      <i class="bi bi-arrow-clockwise" (click)="refreshTickets()"></i>
                    </div>
                  </div>
            </div>
                <div class="row">
                  <div class="col-md-9 col-lg-9" [ngClass]="{'col-lg-6 col-md-6 ': showFilter}">
                    <div class="service-data" [ngClass]="{'show-grid': isDisplayGrid}" *ngIf="!isLoading1">
                      <div class="chart-bar" *ngIf="!isDisplayGrid">
                        <p-chart type="bar" height="650px" ariaLabel="Data" [data]="data" [options]="lineOptions"></p-chart>
                      </div>
                      <div class="chart-bar" *ngIf="isDisplayGrid">
                        <p-chart type="bar" height="350px" [data]="data1" [options]="options"></p-chart>
                      </div>
                      <div class="chart-bar" *ngIf="isDisplayGrid">
                        <p-chart type="bar" height="350px" [data]="data2" [options]="options"></p-chart>
                      </div>
                      <div class="chart-bar" *ngIf="isDisplayGrid">
                        <p-chart type="bar" height="350px" [data]="data3" [options]="options"></p-chart>
                      </div>
                      <div class="chart-bar" *ngIf="isDisplayGrid">
                        <p-chart type="bar" height="350px" [data]="data4" [options]="options"></p-chart>
                      </div>
                    </div>
                    <div class="loader" *ngIf="isLoading1">
                        <div class="spinner"></div>
                      </div>
                  </div>
                  <div class="col-md-3 col-lg-3" style="padding-left: 0;">
                    <!-- <input type="text" placeholder="search" class="form-control"> -->
                    <div class="customerList">
                      <div class="list">
                        <p *ngFor="let list of objectInfoList" (click)="getObjectInfoById(list.objectInfoId)">{{list.givenName}}</p>
                      </div>
                      <div class="loader" *ngIf="isLoading">
                        <div class="spinner"></div>
                      </div>
      
                      <div class="loader" *ngIf="!isLoading && objectInfoList.length == 0">
                        <div class="no-data">
                          <img src="assets/no-data-6.png" alt="">
                          <p>no data found</p>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                  <div class="col-lg-3 col-md-3" *ngIf="showFilter">
                    <div class="filter-block">
                      <div class="filters">
                        <div class="filter-title">
                          <p>Filters</p>
                          <div class="filter-apply-button">
                            <button (click)="resetFilter()">Reset</button>
                            <button (click)="applyFilter()">Apply</button>
                          </div> 
                        </div>
                    

<div class="filter-section">
 
  <!-- Model -->
  <div class="form-group">
    <label>
      <input type="radio" name="filter" (change)="onFilterSelect('modelFilter')"/>
      Model
    </label>
    <input type="text" class="form-control" [(ngModel)]="modelFilter" [disabled]="!modelChecked" />
  </div>

  <!-- Make -->
  <div class="form-group">
    <label>
      <input type="radio" name="filter" (change)="onFilterSelect('makeFilter')"/>
      Make
    </label>
    <input type="text" class="form-control" [(ngModel)]="makeFilter" [disabled]="!makeChecked" />
  </div>

  <!-- Type -->
  <div class="form-group">
    <label>
      <input type="radio" name="filter" (change)="onFilterSelect('typeFilter')"/>
      Type
    </label>
    <select class="form-control" [(ngModel)]="typeFilter" [disabled]="!typeChecked">
      <option value="" selected disabled> -- Select Type --</option>
      <option value="{{object.typeName}}" *ngFor="let object of objectTypeData;let i = index">{{object.typeName}}</option>
    </select>
    <!-- <input type="text" class="form-control" [(ngModel)]="typeFilter" [disabled]="!typeChecked" /> -->
  </div>

    <!-- Group -->
  <div class="form-group">
    <label>
      <input type="radio" name="filter" (change)="onFilterSelect('groupFilter')"/>
      Group
    </label>

    <select class="form-control" [(ngModel)]="groupFilter" [disabled]="!groupChecked">
      <option value="" selected disabled> -- Select Group --</option>
      <option value="{{object.groupName}}" *ngFor="let object of objectGroupData;let i = index">{{object.groupName}}</option>
    </select>
    <!-- <input type="text" class="form-control" [(ngModel)]="groupFilter" [disabled]="!groupChecked" /> -->
  </div>

  <!-- Serial Number -->
  <div class="form-group">
    <label>
      <input type="radio" name="filter" (change)="onFilterSelect('serialNumberFilter')"/>
      Serial Number
    </label>
    <input type="text" class="form-control" [(ngModel)]="serialNumberFilter" [disabled]="!serialNumberChecked" />
  </div>

  <!-- Object Condition -->
  <div class="form-group">
    <label>
      <input type="radio" name="filter" (change)="onFilterSelect('objectConditionFilter')"/>
      Asset Condition
    </label>
    <select class="form-control" [(ngModel)]="objectConditionFilter" [disabled]="!objectConditionChecked">
      <option value="" disabled selected>-- Select Condition --</option>
      <option value="Good">Good</option>
      <option value="UnderRepair">Under Repair</option>
      <option value="Scrap">Scrap</option>
    </select>
  </div>

  <!-- Branch -->
  <div class="form-group">
    <label>
      <input type="radio" name="filter" (change)="onFilterSelect('branchFilter')"/>
      Branch
    </label>
    <select name="" id=""  [(ngModel)]="branchFilter" [disabled]="!branchChecked" class="form-control">
      <option value="" selected disabled> -- Select Branch --</option>
      <option value="{{list.name}}" *ngFor="let list of branchList">{{list.name}}</option>
    </select>
  </div>

  <div class="form-group">
    <label>
      <input type="radio" name="filter" (change)="onFilterSelect('locationFilter')"/>
      Location
    </label>
    <select name="" id="" [(ngModel)]="locationFilter" [disabled]="!locationChecked" class="form-control">
      <option value="" selected disabled> -- Select Location --</option>
      <option value="{{list.city}}" *ngFor="let list of locationList">{{list.city}}</option>
    </select>
  </div>

  

  <!-- Department -->
  <div class="form-group">
    <label>
      <input type="radio" name="filter" (change)="onFilterSelect('departmentFilter')"/>
      Department
    </label>
    <input type="text" class="form-control" [(ngModel)]="departmentFilter" [disabled]="!departmentChecked" />
  </div>



</div>


                      
                      
                      
                        
                        
                      
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>


